import React from 'react';
import PropTypes from 'prop-types';
import { get, noop } from 'lodash';
import Button from '../Button';
import ButtonWrapper from '../ButtonWrapper';
import { Form, FormButtons } from '../form';
import ErrorMessage from '../ErrorMessage';
import SuccessMessage from '../SuccessMessage';

class FormLayout extends React.Component {
  handleCancel = () => {
    this.props.resetForm();
    this.props.onCancel();
  };

  get submitButtonText() {
    if (this.props.submitButtonText) {
      return this.props.submitButtonText;
    }

    return this.props.isEditing ? 'Save' : 'Save & Continue';
  }

  render() {
    const { children, handleSubmit, isEditing, setStatus, status } = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        {children}
        {get(status, 'saveError') && (
          <ErrorMessage>{status.saveError}</ErrorMessage>
        )}
        {get(status, 'hasSaved') && (
          <SuccessMessage
            isOpen={true}
            message="Saved!"
            onExited={() => setStatus({ hasSaved: false })}
          />
        )}
        <FormButtons>
          <ButtonWrapper>
            <Button type="submit">{this.submitButtonText}</Button>
          </ButtonWrapper>
          {isEditing && (
            <ButtonWrapper marginLeft>
              <Button
                color="default"
                onClick={this.handleCancel}
                variant="text"
              >
                Cancel
              </Button>
            </ButtonWrapper>
          )}
        </FormButtons>
      </Form>
    );
  }
}

FormLayout.propTypes = {
  children: PropTypes.node.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  setStatus: PropTypes.func.isRequired,

  isEditing: PropTypes.bool,
  onCancel: PropTypes.func,
  status: PropTypes.object,
  submitButtonText: PropTypes.string,
};

FormLayout.defaultProps = {
  isEditing: false,
  onCancel: noop,
  status: {},
  submitButtonText: undefined,
};

export default FormLayout;



// WEBPACK FOOTER //
// ./src/modules/common/layouts/FormLayout.js